import { CloseIcon } from "components/ui/icons/uploadbar/CloseIcon"
import style from "./ConnectObjectsBar.module.scss"

const { bar, prompt, title, hint, selection, count, connectButton, closeButton } = style

type Props = {
	/** Elevation number of the target eref, e.g. "17-A-101". */
	elevationLabel: string
	selectedCount: number
	isPending?: boolean
	onConnect: () => void
	onCancel: () => void
}

/**
 * Top bar of the eref "Connect objects" mode (REQ-372). Two states, per Figma: with nothing
 * selected it explains how to pick objects; once objects are selected it shows the count plus the
 * Connect action. Presentational only — the marquee/click selection, the eligibility rules and the
 * request all live in `interactions/useErefConnectObjects`.
 */
export const ConnectObjectsBar = ({
	elevationLabel,
	selectedCount,
	isPending = false,
	onConnect,
	onCancel,
}: Props) => {
	return (
		<div className={bar} role="toolbar" aria-label="Connect objects to elevation" data-testid="connect-objects-bar">
			{selectedCount > 0 ? (
				<div className={selection}>
					<span className={count}>
						{selectedCount} {selectedCount === 1 ? "object" : "objects"} selected
					</span>
					<button type="button" className={connectButton} onClick={onConnect} disabled={isPending}>
						Connect
					</button>
				</div>
			) : (
				<div className={prompt}>
					<span className={title}>Connect objects to {elevationLabel}</span>
					<span className={hint}>Click on detection or drag to select multiple</span>
				</div>
			)}
			<button
				type="button"
				className={closeButton}
				onClick={onCancel}
				disabled={isPending}
				aria-label="Cancel connecting objects"
			>
				<CloseIcon />
			</button>
		</div>
	)
}
